import { InputProps } from '../OdfjellInputComponent';

const CheckboxInputComponent: React.FC<Partial<InputProps>> = ({ value, name, elementId, onChange, tabIndex }: Partial<InputProps>) => {
    return (
        <input
            type="checkbox"
            name={name}
            id={elementId}
            value={value}
            onChange={(event) => onChange({ event })}
            checked={value || false}
            autoComplete="off"
            tabIndex={tabIndex}
        ></input>
    );
};

export default CheckboxInputComponent;
